// Import necessary hooks, components, and utilities from React, Material UI, and other libraries
import { useState, useReducer, useEffect } from "react";
import { useParams } from "react-router-dom";
import { ResubmitRequestContext, resubmitRequestReducer } from "./";
import { ResubmitRequestDetailsView } from "./ResubmitRequestDetailsView";
import Grid from "@mui/material/Grid";
import axios from "axios";
import { apiURI, authErrorRedirect } from "../../../common";
import { useNavigate } from "react-router-dom";

export function ResubmitRequest() {
  // State to store the request data fetched from the API
  const [requestData, setRequestData] = useState();
  // State to store any errors encountered during the API call
  const [errors, setErrors] = useState();
  // Use the useParams hook to get the ID from the URL parameters
  const { id } = useParams();
  // Initialize the state and dispatch function using the useReducer hook with the resubmitRequestReducer
  const [state, dispatch] = useReducer(resubmitRequestReducer, {
    itemList: "",
    sampleRequestDetails: "",
    sampleRequestFormDisplay: "flex",
  });
  const history = useNavigate();

  // Use the useEffect hook to fetch request data from the API when the component mounts or the ID changes
  useEffect(() => {
    axios
      .get(`${apiURI}/form/id/${id}`)
      .then((response) => {
        setRequestData(response.data);
      })
      .catch((response) => {
        console.log("error in axios form call react", response);
        setErrors({});
        setErrors(response.response.data);
        authErrorRedirect(response.response.data, history);
      });
    // eslint-disable-next-line no-console
  }, [id]);

  errors && console.log({ errors });

  return (
    <ResubmitRequestContext.Provider value={{ state, dispatch }}>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        marginTop="50px"
        sx={{
          marginLeft: "auto",
          marginRight: "auto",
          paddingBottom: 4,
          maxWidth: "100vw",
        }}
      >
        {/* Render the ResubmitRequestDetailsView component if requestData is available */}
        {requestData && (
          <ResubmitRequestDetailsView requestData={requestData} />
        )}
      </Grid>
    </ResubmitRequestContext.Provider>
  );
}
